import Vue from 'vue';
import axios from 'axios';
import { LMap, LTileLayer, LMarker, LPolyline } from 'vue2-leaflet';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';

import L from "leaflet";

Vue.component('l-map', LMap);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-polyline', LPolyline);

//delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

export default {
  name: 'mapLocation',
  props: {
    dataObj: {
      type: Object,
      default: {}
    },
    parentComp: {
      type: Object,
      default: {}
    }
  },
  data: function () {
    return {
      locationAquisitionFailed: false,
      mapDiv: { map: null, defaultZoom: 15 },
      gisSettings: {},
      url: '',
      attribution:
        '&copy; <a target="_blank" href="https://hydro-comp.com/">Hydro-Comp</a> contributors',
      zoom: 15,
      center: [],
      markers: [],

      layers: [],
      selectedType: {},

      polyline: {
        latlngs: [
          
        ],
        color: "orange"
      },
      lrsFirstIcon: {},
      lrsSecondIcon: {},
      defaultIcon: {},
      lrsFirstIconUrl: 'http://maps.google.com/mapfiles/kml/paddle/blu-circle.png',
      lrsSecondIconUrl: 'http://maps.google.com/mapfiles/kml/paddle/orange-circle.png',

      polylineInitStyle: {
        color: 'orange',
        weight: 3
      },
      errorMessage: '',
      message: '',
      addMapClickEvents: false,
      addMapDoubleEvents: false,
      addMapMouseOverEvents: false,
      addMapDragEndEvents: false,

      markerTitle: this.$t('messages.MarkerTitle'),
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -50
        }
      },
      bDraggable: true,
      bClickable: true,
      bEditLocation: false,
      readOnly: false,
    }
  },
  computed: {
    mapProvider: function () {
      return this.gisSettings.mapProvider;
    },
  },
  mounted() {
    
  },
  created() {
    this.getGisSettings();

    this.defaultIcon = L.icon({
      iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
      iconAnchor: [12, 41],
      popupAnchor: [12, -41]
    });
  },
  methods: {
    getGisSettings() {
      axios.post('/gis/GetGisSettings')
        .then(response => {
          //response.data.mapProvider = 3;
          this.gisSettings = response.data;

          this.$root.$on('gmap_location_updated', this.init);
          this.init;
        })
        .catch(error => {
          console.log(error);
        });
    },
    init() {
      Vue.nextTick(() => {
        this.center = []
        this.center.push(this.dataObj.gMapPosition.lat);
        this.center.push(this.dataObj.gMapPosition.lng);

        //this.gMapPositionStart = this.dataObj.gMapPositionStart;
        //this.gMapPositionMove = this.dataObj.gMapPositionMove;
        //this.markerTitle = this.dataObj.markerTitle;
        //this.infoContent = this.dataObj.infoContent;
        //this.infoWindowPos = this.dataObj.infoWindowPos;
        //this.infoWinOpen = this.dataObj.infoWinOpen;
        //this.infoOptions = this.dataObj.infoOptions;
        this.bDraggable = this.dataObj.bDraggable;
        //this.bClickable = this.dataObj.bClickable;
        this.bEditLocation = this.dataObj.bEditLocation;
        this.readOnly = this.dataObj.readOnly;

        

        if (this.center[0] === 0 && this.center[1] === 0)
          this.getGeoLocation();

        setTimeout(() => {
          //var map = this.$refs.myMap;
          //map.$mapObject.setOptions({ disableDoubleClickZoom: true });

          //this.google.maps.event.addListener(map.$mapObject, 'dblclick', (e) => {
          //  var positionDoubleclick = e.latLng;
          //  this.setMarker(positionDoubleclick);
          //});

          this.setupLeafletMap();

        }, 1000);

        setTimeout(() => {
          this.centerMap();
        }, 10000);
      });
    },
    closeMapDialog() {
      this.bEditLocation = false;
      this.dataObj.bEditLocation = false;
    },
    setupLeafletMap: function () {
      document.getElementById('mapContainer').innerHTML = '';

      var container = L.DomUtil.get('mapContainer');
      if (container != null) {
        container['_leaflet_id'] = null;
      }

      this.mapDiv.map = L.map("mapContainer").setView(this.center, this.mapDiv.defaultZoom);

      if (this.gisSettings.mapProvider == 0) {
        L.tileLayer('http://{s}.google.com/vt?lyrs=m&x={x}&y={y}&z={z}',
          {
            subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
            attribution: '© Google Maps'
          }
        ).addTo(this.mapDiv.map);
      } else if (this.gisSettings.mapProvider == 3) {
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
          {
            attribution: '© OpenStreetMap'
          }
        ).addTo(this.mapDiv.map);
      }

      this.mapDiv.map.on('dblclick', (e) => {
        //this.markers[0].position.lat = e.latlng.lat;
        //this.markers[0].position.lat = e.latlng.lng;

        this.dataObj.gMapPosition.lat = e.latlng.lat;
        this.dataObj.gMapPosition.lng = e.latlng.lng;
        this.$alertMsg(this.$t('messages.LocationPointSuccess'), 2);
        this.closeMapDialog();
      });

      this.markers = [];
      this.markers.push({ position: { lat: this.center[0], lng: this.center[1] }, draggable: this.bDraggable, icon: this.defaultIcon });

      for (var i = 0; i < this.markers.length; i++) {
        const marker = L.marker(this.markers[i].position,
          {
            draggable: this.markers[i].draggable == undefined ? false : this.markers[i].draggable,
            icon: this.defaultIcon
          }
        ).addTo(this.mapDiv.map);

        if (this.bDraggable) {
          marker.on('dragend', (e) => {
            this.markers[0].position.lat = e.target.getLatLng().lat;
            this.markers[0].position.lng = e.target.getLatLng().lng;

            this.dataObj.gMapPosition.lat = e.target.getLatLng().lat;
            this.dataObj.gMapPosition.lng = e.target.getLatLng().lng;

            this.$alertMsg(this.$t('messages.LocationPointSuccess'), 2);
          });
        }
      }
    },
    getGeoLocation() {
      var geoOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };

      var geo = navigator.geolocation.getCurrentPosition(
        (pos) => {
          this.center = [];

          this.center.push(pos.coords.latitude);
          this.center.push(pos.coords.longitude);
        },
        (err) => { this.$alertMsg(err.message); },
        geoOptions
      );
    },

    async centerMap() {
      //center around point and zoom to have the both visible
      var geoOptions = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };


      await navigator.geolocation.getCurrentPosition(
        (pos) => {
          if (pos.coords.latitude && pos.coords.longitude) 
            this.mapDiv.map.setZoom(this.mapDiv.defaultZoom).panTo([pos.coords.latitude, pos.coords.longitude]);          
        },
        (err) => {
          this.$alertMsg(err.message);
          this.locationAquisitionFailed = true;
        },
        geoOptions
      );
    },
  }
}
